import { getAppConfigSetting, requests } from 'utils';
import { URL } from './constants';

export function addressPreviewRequest(accountId) {
  const payload = {
    account: accountId,
    deliveryMethod: 'STANDARD',
    beneficiaryDetails: {
      isThirdParty: false,
      name: 'string',
    },
  };
  return requests.post(URL(getAppConfigSetting('sentinelApiUrl')), JSON.stringify(payload));
}



// WEBPACK FOOTER //
// ./src/services/addressPreview/api.js